export default __webpack_public_path__ + "static/media/house.36de7c3f.svg";